import React from "react"
import {connect} from "react-redux"
import {createStructuredSelector} from "reselect"
import styled from "styled-components"
import {Boundary} from "../../components/Boundary"
import {Firebase} from "../../components/Firebase"
import {Flex} from "../../components/Flex"
import {HeaderLinks} from "../../components/HeaderLinks"
import arrowUpWhiteSrc from "../../images/arrow-up-white.svg"
import {Calculations} from "../../projects/costProjection/components/Calculations"
import {Layout} from "../../projects/costProjection/components/Layout"
import {SearchField} from "../../projects/costProjection/components/SearchField"

class Search extends React.Component {
  componentDidMount() {
    this.firebase = new Firebase()
  }

  render() {
    return (
      <Layout>
        <Boundary>
          <OuterDiv>
            <br />
            <br />
            <br />
            <Flex>
              <div style={{flexGrow: 1}}>
                <SearchField />
              </div>
              <Flex>
                <CreateNewButton>
                  <span>+</span>
                  Create a calc
                </CreateNewButton>
                <CreateNewButton>
                  <div>
                    <img alt="Arrow up" src={arrowUpWhiteSrc} />
                  </div>
                  Upload a file
                </CreateNewButton>
              </Flex>
            </Flex>
            <br />
            <br />
            <LinksDiv>
              <HeaderLinks
                links={[
                  {
                    isActive: true,
                    name: "My calcs",
                  },
                  {
                    name: "Calcs shared with me",
                  },
                  {
                    name: "Calcs shared with organization",
                  },
                ]}
              />
            </LinksDiv>
            <Calculations />
          </OuterDiv>
        </Boundary>
      </Layout>
    )
  }
}

const CreateNewButton = styled.div`
  background-color: #60a7ff;
  border-radius: 3px;
  color: white;
  cursor: pointer;
  height: 60px;
  line-height: 60px;
  font-weight: 500;
  padding: 0 2em 0 3.2em;
  position: relative;
  div,
  span {
    font-size: 1.6em;
    font-weight: normal;
    left: 0.9em;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  span {
    margin-top: -0.08em;
  }
  img {
    height: 0.63em;
  }
  &:not(:first-child) {
    margin-left: 1em;
  }
`

const LinksDiv = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.borderColorLight};
`

const OuterDiv = styled.div`
  margin-bottom: ${(props) => props.theme.gutter / 2}px;
  padding-top: ${(props) => props.theme.headerHeight}px;
`

const createSelectors = createStructuredSelector({})

export default connect(createSelectors, {})(Search)
